import { detectMisalignedDatapoints } from './detectInconsistencies.js';
import {
  TimeseriesPerVariant,
  ValueRepresentationPerVariant,
} from '../types/timeseries.js';

export function getSanitizedValueRepresentation(
  data: TimeseriesPerVariant,
  valueRepPerVariant: ValueRepresentationPerVariant,
) {
  const { area } = data;

  if (area && area.length > 0) {
    const valueRepresentation = valueRepPerVariant.get('area') ?? 'absolute';
    const misalignedDatapoints = detectMisalignedDatapoints(area);
    const isMisaligned =
      misalignedDatapoints && valueRepresentation === 'relative';

    valueRepPerVariant.set(
      'area',
      isMisaligned ? 'absolute' : valueRepresentation,
    );
  }

  return valueRepPerVariant;
}
